export const MIN_CELL_HEIGHT = 36
export const MIN_CELL_WIDTH = 41
export const TABLE_RESIZE_SNAP_DELTA = 10
